import { useEffect, useState, } from 'react';
import { Modal } from 'react-bootstrap';
import { v4 as uuidv4 } from 'uuid';
import Swal from 'sweetalert2';
import axios from 'axios';

import { fileModelGet } from '../../models/main/files';
import { fileUploadAsync } from '../../controllers/dataBase/actions';
import {
    checkFile, dataTableLanguaje, documentMaxFilesMessageGet, formatBytes, buttonProcessGet, customFileNameGet, globalSettings, processEvaluateGet, responseGet, sendMessageCloseCurrentWindowAsync,
    styles, languageObjGet, isUndNullEmp, awaitDelay, LoadingSection
} from '../../helpers/settings';
import { purchaseModelGet } from '../../models/expenses/purchase';
import { GlobalFormats } from '../../classes/main/globalFormats';

const currentMethod = 'PurchaseFiles';

export default function PurchaseFiles({
    $ = {},
    auth = {},
    userRole = '',
    showModal = false,
    setShowModal = () => { },
    purchase = purchaseModelGet({}),
    setPurchase = () => { },
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result;
    let dataObj = {};
    let headerObj = {};
    const dtFilesId = 'dtFiles';
    //const inputFileId = 'inputFile';
    //const btnFileDeleteId = 'btnFileDelete';
    const [btnFileAddDisabled, setBtnFileAddDisabled] = useState(false);
    const [fileDelete, setFileDelete] = useState({ fileId: '', description: '', rowIndex: 0, });
    const [filesAccept, setFilesAccept] = useState('');
    //#region old code
    // const fileTypes = concat(
    //     globalSettings?.app?.fileTypes?.images,
    //     globalSettings?.app?.fileTypes?.filesOnlyPdf,
    // );
    //#endregion old code
    const fileTypes = globalSettings?.app?.fileTypes?.images?.concat(globalSettings?.app?.fileTypes?.filesOnlyPdf);
    const isNotEditable = !((purchase.balance === purchase.total) && purchase.status === 1);
    const [isEditDelete, setIsEditDelete] = useState(false);
    const [showLoading, setShowLoading] = useState(false);
    const controls = {
        buttons: {
            add: {
                id: 'btnModalPurchaseFilesAdd',
                className: 'btn btn-outline-info btn-file mx-1',
                defaultClassDisabled: 'btn btn-outline-info btn-file mx-1 disabled',
            },
            back: {
                id: 'btnModalPurchaseFilesBack',
                className: 'btn btn-outline-success',
            },
            delete: {
                id: 'btnModalPurchaseFilesDelete',
                className: 'btn btn-outline-danger'
            },
            close: {
                id: 'btnModalPurchaseFilesClose',
                className: 'close btn-danger fas fa-window-close',
            },
        },
        inputs: {
            // quantity: {
            //     id: 'inputModalPurchaseFilesQuantity',
            //     className: 'form-control text-right',
            // },
        },
        dataTables: {
            files: {
                buttons: {
                    // create: {
                    //     className: 'btn btn-outline-success float-right btn-sm',
                    //     id: 'btnDtExpenseConceptsCreate',
                    // },
                },
                icons: {
                    // create: {
                    //     id: 'iconDtExpenseConceptsCreate',
                    //     className: globalSettings?.icons?.plusCircle,
                    // },
                },
                inputs: {
                    search: {
                        id: `${dtFilesId}_filter input`,
                        className: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtFilesId}_length select`,
                        className: '',
                    },
                },
                spinners: {
                    // create: {
                    //     id: 'spDtExpenseConceptsCreate',
                    //     className: '',
                    // },
                },
            },
        },
        icons: {
            add: {
                id: 'icoModalPurchaseFilesAdd',
                className: globalSettings?.icons?.paperClip,
            },
            delete: {
                id: 'icoModalPurchaseFilesDelete',
                className: globalSettings?.icons?.eraser,
            },
            back: {
                id: 'icoModalPurchaseFilesBack',
                className: globalSettings?.icons?.arrowCircleLeft,
            },
        },
        spinners: {
            add: {
                id: 'spModalPurchaseFilesAdd',
                className: '',
            },
            delete: {
                id: 'spModalPurchaseFilesDelete',
                className: '',
            },
            back: {
                id: 'spModalPurchaseFilesBack',
                className: '',
            },
        },
    };
    //#endregion variables

    //#region files (methods)
    const fileAddAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'fileAddAsync';
        let response = responseGet();
        try {
            //#region variables
            let dtRows = [];
            let fileInputObj = {};
            let fileFindLocal = [];
            let fileObj = {
                id: '',
                nameCustom: '',
                sizeCustom: '',
                path: '',
                url: '',
            };
            let fileObjNew = fileModelGet({});
            let purchaseAfter = purchaseModelGet({});
            //#endregion variables

            //#region initialize
            fileObj.path = e?.target?.value;
            fileInputObj = e?.target?.files?.[0];
            //#endregion initialize

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region add file
            if (!isUndNullEmp({ data: fileObj?.path, subMethod: currentMethod, })?.result) {
                //#region check file
                response = checkFile({
                    fileType: fileInputObj?.type,
                    fileSize: fileInputObj?.size,
                    fileAllowedTypes: fileTypes,
                    fileMaxSize: globalSettings?.app?.fileSize?.max,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) {
                    controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                    $(`#${controls?.buttons?.add?.id}`).val('');
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }
                //#endregion check file

                if (!isUndNullEmp({ data: purchase?.files, subMethod: currentMethod, })?.result && purchase?.files?.length > 0) {
                    fileFindLocal = purchase?.files?.filter(
                        ({ name, size, type, path, }) => name === fileInputObj?.name && size === fileInputObj?.size && type === fileInputObj?.type && path === fileObj?.path)?.[0] || [];
                }

                if (isUndNullEmp({ data: fileFindLocal, subMethod: currentMethod, })?.result || fileFindLocal?.length <= 0) {
                    //#region check files maximum
                    if (!isUndNullEmp({ data: purchase?.files, subMethod: currentMethod, })?.result && purchase?.files?.length >= globalSettings?.app?.files?.apartmentReceiptPaymentFileMaxFiles) {
                        response = documentMaxFilesMessageGet({
                            maxFiles: globalSettings?.app?.files?.purchaseMaxFiles,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });

                        if (!response?.isSuccess || response?.isWarning) {
                            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                            $(`#${controls?.buttons?.add?.id}`).val('');
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            });
                            return;
                        }
                    }
                    //#endregion check files maximum

                    //#region upload file (new)
                    fileObj.id = uuidv4();
                    fileObj.nameCustom = customFileNameGet({
                        fileName: fileInputObj?.name,
                        lengthStart: 0,
                        lengthReturn: 20,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    })?.result;
                    fileObj.sizeCustom = formatBytes({
                        bytes: fileInputObj.size,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    })?.result;

                    //#region upload file
                    response = await fileUploadAsync({
                        folder: globalSettings?.app?.backend?.documents?.purchaseFiles,
                        file: fileInputObj,
                        fileName: fileObj?.id,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });

                    if (!response?.isSuccess || response?.isWarning) {
                        controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                        $(`#${controls?.buttons?.add?.id}`).val('');
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        return;
                    }

                    fileObj.url = response?.result;
                    //#endregion upload file
                    //#endregion upload file (new)

                    fileObjNew = fileModelGet({
                        id: fileObj?.id,
                        name: fileInputObj?.name,
                        nameCustom: fileObj?.nameCustom,
                        path: fileObj?.path,
                        size: fileInputObj?.size,
                        sizeCustom: fileObj?.sizeCustom,
                        type: fileInputObj?.type,
                        url: fileObj?.url,
                    });

                    //#region update purchase
                    if (isUndNullEmp({ data: purchase?.files, subMethod: currentMethod, })?.result) {
                        purchase.files = [];
                    }

                    //#region old code
                    //purchase?.files?.push(fileObjNew);
                    //#endregion old code
                    purchaseAfter = Object?.assign({}, purchase);
                    purchaseAfter?.files?.push(fileObjNew);

                    //#region update purchase
                    //#region old code
                    //purchase.notUpdateDetails = true;
                    //#endregion old code
                    response = await purchaseUpdateByIdAsync({
                        id: purchase?.id,
                        //#region old code
                        //purchase: purchase,
                        //#endregion old code
                        purchase: purchaseAfter,
                        updateDetails: false,
                        subMethod: currentMethod,
                    });

                    if (!response?.isSuccess || response?.isWarning) {
                        controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                        $(`#${controls?.buttons?.add?.id}`).val('');
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        return;
                    }

                    //#region old code
                    //delete response.result.notUpdateDetails;
                    //#endregion old code
                    //#region old code
                    //setPurchase(response?.result?.purchase);
                    //#endregion old code
                    purchaseAfter = response?.result?.purchase;
                    purchase = purchaseAfter;
                    setPurchase(purchaseAfter);
                    //#endregion update purchase

                    //#region add dataTable row (purchase files)
                    dtRows = [];
                    dtRows.push(
                        fileObj?.nameCustom,
                        fileObj?.sizeCustom,
                        buttonProcessGet({
                            id: fileObj?.id,
                            description: customFileNameGet({
                                fileName: fileInputObj?.name,
                                lengthStart: 0,
                                lengthReturn: 20,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            })?.result,
                            showDetails: false,
                            labelDetails: '',
                            enabledDetails: false,
                            showEdit: false,
                            labelEdit: '',
                            enabledEdit: false,
                            showDelete: false,
                            labelDelete: '',
                            enabledDelete: false,
                            processButtons: [
                                { isVisible: true, showDivider: false, isEnabled: true, methodName: 'fileOpen', icon: globalSettings?.icons?.folderOpen, label: globalSettings?.labels?.open?.[languageObj?.id] },
                                { isVisible: true, showDivider: false, isEnabled: true, methodName: 'fileDelete', icon: globalSettings?.icons?.trash, label: globalSettings?.labels?.delete?.[languageObj?.id] },
                            ],
                            subMethod: currentMethod,
                        })?.result,
                    );
                    $(`#${dtFilesId}`)?.DataTable()?.row?.add(dtRows)?.draw(true);
                    //#endregion add dataTable row (purchase files)
                    //#endregion update purchase
                }
            }
            $(`#${controls?.buttons?.add?.id}`).val('');
            //#endregion add file

            controlsStatusSet({ processType: 0, subMethod: currentMethod, });

            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: globalSettings?.messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            $(`#${controls?.buttons?.add?.id}`).val('');
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const fileOpenAsync = async ({ e = {}, fileId = '', description = '', rowIndex = 0, subMethod = '', }) => {
        const currentMethod = 'fileOpenAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod })?.result) {
                e?.preventDefault();
            }

            //#region variables
            let fileLocal = fileModelGet({});
            let purchaseLocal = purchaseModelGet({});
            //#endregion variables

            setShowLoading(true);

            //#region purchase get
            response = await purchaseGetByIdAsync({
                id: purchase?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading(false);
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            purchaseLocal = response?.result?.purchase || {};
            //#endregion purchase get

            //#region Open file
            if (!isUndNullEmp({ data: purchaseLocal?.files, subMethod: currentMethod, })?.result && purchaseLocal?.files?.length > 0) {
                fileLocal = purchaseLocal?.files?.find(({ id, }) => id === fileId);

                if (!isUndNullEmp({ data: fileLocal?.url, subMethod: currentMethod, })?.result) {
                    //#region check if file exists
                    headerObj = {
                        headers: {
                            authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                        },
                    };

                    dataObj = {
                        buildingId: purchaseLocal?.buildingId,
                        fileName: fileLocal?.id,
                        folder: globalSettings?.app?.backend?.documents?.purchaseFiles,
                        limit: 0,
                        ordersBy: [],
                        conditionals: [],
                        method: globalSettings?.app?.backend?.methods?.fileUrlDownloadGet,
                        url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlFiles}/`,
                    };

                    result = await axios?.post(
                        dataObj?.url,
                        dataObj,
                        headerObj,
                    );

                    response = result?.data;

                    if (!response?.isSuccess || response?.isWarning) {
                        setShowLoading(false);
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        return;
                    }

                    //#endregion check if file exists
                    window?.open(fileLocal?.url, '_blank');
                } else {
                    setShowLoading(false);
                    response.msgType = 1;
                    response.msgText = `${globalSettings?.messages?.theFileCannotBeLocated?.[languageObj?.id]}<br/>`;
                    response.msgText += `${globalSettings?.labels?.file?.[languageObj?.id]}: <b>${description}</b>`;
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }
            } else {
                setShowLoading(false);
                response.msgType = 1;
                response.msgText = `${globalSettings?.messages?.theFileCannotBeLocated?.[languageObj?.id]}<br/>`;
                response.msgText += `${globalSettings?.labels?.file?.[languageObj?.id]}: <b>${description}</b>`;
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion Open file

            setShowLoading(false);
        } catch (ex) {
            setShowLoading(false);
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const fileDeleteGetAsync = async ({ e = {}, fileId = '', description = '', rowIndex = 0, subMethod = '', }) => {
        const currentMethod = 'fileDeleteGetAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region old code
            //#region check user
            // if (!avancessProcess) {
            //     // response = sufficientPrivilegesMessageGet();
            //     // sendMessage(response.msgType, response.msgText, 0, true, false, null, '');
            //     sendMessage(1, globalSettings?.messages?.youDoNotHaveSufficientPrivilegesToRunThisProcess?.[languageObj?.id], 0, true, false, null, '');
            //     return response;
            // }
            //#endregion check user
            //#endregion old code

            //#region old code
            // //#region show message
            // const swalProperties = {
            //     icon: globalSettings?.react?.sweetAlert2?.icons?.warning,
            //     title: globalSettings?.messages?.areYouSureDeleteThis?.[languageObj?.id],
            //     html: `${globalSettings?.labels?.file?.[languageObj?.id]}: <b>${description}</b><br/>${globalSettings?.messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
            //     timer: null,
            //     confirmButtonColor: globalSettings?.colors?.warningColorExp,
            //     confirmButtonText: globalSettings?.labels?.yes?.[languageObj?.id],
            //     showCancelButton: true,
            //     cancelButtonColor: globalSettings?.colors?.successColorExp,
            //     cancelButtonText: globalSettings?.labels?.no?.[languageObj?.id],
            //     didOpen: () => {
            //         Swal.hideLoading();
            //     },
            // };

            // //#region old code
            // // Swal.fire(swalProperties).then((result) => {
            // //     if (result.isConfirmed) {
            // //         setFileDelete({ fileId, description, rowIndex });
            // //         $(`#${btnFileDeleteId}`)?.trigger('click');
            // //     }
            // // });
            // //#endregion old code

            // const { isConfirmed, } = await Swal.fire(swalProperties);
            // //#endregion show message
            //#endregion old code

            //#region old code
            // //#region delete data
            // if (isConfirmed) {
            //     setFileDelete({ fileId, description, rowIndex });
            //     $(`#${controls?.buttons?.delete?.id}`)?.trigger('click');
            // }
            // //#endregion delete data
            //#endregion old code

            setFileDelete({ fileId, description, rowIndex });
            $(`#${controls?.buttons?.delete?.id}`)?.trigger('click');
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const fileDeletePostAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'fileDeletePostAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            //#endregion variables

            //#region show message
            let msgTextObj = {
                one: `${globalSettings?.labels?.file?.[languageObj?.id]}: <b>${fileDelete?.description}</b><br/>`,
                two: `${globalSettings?.messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
            };

            let swalProperties = {
                icon: globalSettings?.react?.sweetAlert2?.icons?.warning,
                title: globalSettings?.messages?.areYouSureDeleteThis?.[languageObj?.id],
                html: `${msgTextObj?.one}${msgTextObj?.two}`,
                timer: null,
                backdrop: true,
                confirmButtonColor: globalSettings?.colors?.warningColorExp,
                confirmButtonText: globalSettings?.labels?.yes?.[languageObj?.id],
                showCancelButton: true, //!Swal.isLoading(), //true,
                cancelButtonColor: globalSettings?.colors?.successColorExp,
                cancelButtonText: globalSettings?.labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                didOpen: () => {
                    Swal.hideLoading();
                },
                preConfirm: async () => {
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal?.update({
                            icon: globalSettings?.react?.sweetAlert2?.icons?.info,
                            title: `${globalSettings?.messages?.processing?.[languageObj?.id]}...`,
                            html: `${msgTextObj?.one}`,
                            showConfirmButton: false,
                        });

                        if (!isUndNullEmp({ data: purchase?.files, subMethod: currentMethod, })?.result && purchase?.files?.length > 0) {
                            //#region delete file (physical)
                            headerObj = {
                                headers: {
                                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                                },
                            };

                            dataObj = {
                                buildingId: purchase?.buildingId,
                                limit: 0,
                                ordersBy: [],
                                conditionals: [],
                                folder: globalSettings?.app?.backend?.documents?.purchaseFiles,
                                fileName: fileDelete?.fileId,
                                method: globalSettings?.app?.backend?.methods?.fileDelete,
                                languageId: languageObj?.id,
                                url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlFiles}/`,
                            };

                            result = await axios?.post(
                                dataObj?.url,
                                dataObj,
                                headerObj
                            );

                            response = result?.data;

                            if (!response?.isSuccess || response?.isWarning) {
                                await sendMessageCloseCurrentWindowAsync({
                                    msgType: response?.msgType,
                                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                    closeWindow: false,
                                    urlGoTo: response?.urlGoTo,
                                    auth: auth,
                                    isLogout: false,
                                    languageId: languageObj?.id,
                                    subMethod: currentMethod,
                                });
                                return;
                            }
                            //#endregion delete file (physical)

                            //#region delete file (logical)
                            purchase.files = purchase?.files?.filter(({ id, }) => id !== fileDelete?.fileId) || [];

                            if (isUndNullEmp({ data: purchase?.files, subMethod: currentMethod, })?.result || purchase?.files?.length <= 0) {
                                purchase.files = [];
                            }
                            //#endregion delete file (logical)

                            //#region update purchase (delete file)
                            //#region old code
                            //purchase.notUpdateDetails = true;
                            //#endregion old code
                            response = await purchaseUpdateByIdAsync({
                                id: purchase?.id,
                                purchase: purchase,
                                updateDetails: false,
                                subMethod: currentMethod,
                            });

                            if (!response?.isSuccess || response?.isWarning) {
                                await sendMessageCloseCurrentWindowAsync({
                                    msgType: response?.msgType,
                                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                    closeWindow: false,
                                    urlGoTo: response?.urlGoTo,
                                    auth: auth,
                                    isLogout: false,
                                    languageId: languageObj?.id,
                                    subMethod: currentMethod,
                                });
                                return;
                            }

                            //#region old code
                            //delete response.result.notUpdateDetails;
                            //#endregion old code
                            setPurchase(response?.result?.purchase || {});
                            //#endregion update purchase (delete file)
                        }

                        //#region purchase file (datatable)
                        $(`#${dtFilesId}`)?.DataTable()?.row(fileDelete?.rowIndex)?.remove()?.draw(true);
                        //#endregion purchase file (datatable)

                        //#region final message
                        response.msgType = 0;
                        response.msgText = `${globalSettings?.messages?.fileDeletedSuccessFully?.[languageObj?.id]}<br/>`;
                        response.msgText += `${globalSettings?.labels?.file?.[languageObj?.id]}: <b>${fileDelete?.description}</b>`;
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        //#endregion final message
                    } catch (ex) {
                        //#region Error
                        response.isSuccess = false;
                        response.msgType = -1;
                        response.msgText = `Method: ${currentMethod}<br/>`;
                        response.msgText += `Error: ${ex?.message}`;
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                        });
                        //#endregion Error
                    }
                },
                allowOutsideClick: () => !Swal.isLoading(),
            };

            await Swal.fire(swalProperties);
            //#endregion show message
        } catch (ex) {
            setShowLoading(false);
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }
    //#endregion files (methods)

    //#region purchases (methods)
    const purchaseGetByIdAsync = async ({ id = '', subMethod = '' }) => {
        const currentMethod = 'purchaseGetByIdAsync';
        let response = responseGet();
        try {
            //#region data get
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                    languageId: languageObj?.id,
                },
                url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlPurchases}/${id}`,
            };

            result = await axios?.get(
                headerObj?.url,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }
            //#endregion data get
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const purchaseUpdateByIdAsync = async ({ id = '', purchase = purchaseModelGet({}), updateDetails = false, subMethod = '', }) => {
        const currentMethod = 'purchaseUpdateByIdAsync';
        let response = responseGet();
        try {
            //#region purchase update
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                purchase: purchase,
                updateDetails: updateDetails,
                languageId: languageObj?.id,
                languageCode: languageObj?.code,
                url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlPurchases}/${id}`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }
            //#endregion purchase update
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`
        }
        return response;
    }

    //#endregion purchases (methods)

    //#region  methods
    const dataGetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            setBtnFileAddDisabled(false);

            //#region variables
            let dtRows = [];
            let isEdit = false;
            let isDelete = false;
            let fileAccepts = '';
            //#endregion variables

            //#region dataTable set
            response = await dataTablesSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion dataTable set

            //#region query set
            response = await queryCodeSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion query set

            //#region set is edit / delete
            isEdit = processEvaluateGet({
                object: purchase,
                property: globalSettings?.labels?.process?.en?.toLowerCase(),
                process: globalSettings?.labels?.edit?.en?.toLowerCase(),
                subMethod: currentMethod,
            })?.result;
            isDelete = isEdit;
            setIsEditDelete(!(isEdit && isDelete));
            //#endregion set is edit / delete

            //#region set dtRows
            if (!isUndNullEmp({ data: purchase?.files, subMethod: currentMethod, })?.result && purchase?.files?.length > 0) {
                dtRows = [];
                purchase?.files?.forEach((detail) => {
                    dtRows.push([
                        detail.nameCustom,
                        detail.sizeCustom,
                        buttonProcessGet({
                            id: detail.id,
                            description: detail.nameCustom,
                            showDetails: false,
                            labelDetails: '',
                            enabledDetails: false,
                            showEdit: false,
                            labelEdit: '',
                            enabledEdit: false,
                            showDelete: false,
                            labelDelete: '',
                            enabledDelete: false,
                            processButtons: [
                                { isVisible: true, showDivider: false, isEnabled: true, methodName: 'fileOpen', icon: globalSettings?.icons?.folderOpen, label: globalSettings?.labels?.open?.[languageObj?.id] },
                                //{ isVisible: true, showDivider: false, isEnabled: avancessProcess, methodName: 'fileDelete', icon: globalSettings?.icons?.trash, label: globalSettings?.labels?.delete?.[languageObj?.id] },
                                //{ isVisible: true, showDivider: false, isEnabled: isEditDelete && isNotEdiable, methodName: 'fileDelete', icon: globalSettings?.icons?.trash, label: globalSettings?.labels?.delete?.[languageObj?.id] },
                                { isVisible: true, showDivider: false, isEnabled: !isNotEditable && (isEdit && isDelete), methodName: 'fileDelete', icon: globalSettings?.icons?.trash, label: globalSettings?.labels?.delete?.[languageObj?.id] },
                            ],
                            subMethod: currentMethod,
                        })?.result,
                    ]);
                });

                $(`#${dtFilesId}`)?.DataTable()?.rows?.add(dtRows)?.draw(true);
            }
            //#endregion set dtRows

            //#region filesAccept set
            fileAccepts = '';
            fileTypes?.forEach((detail, index) => {
                if ((index + 1) < fileTypes?.length) {
                    fileAccepts += `${detail}, `;
                } else {
                    fileAccepts += `${detail}`;
                }
            });

            setFilesAccept(fileAccepts);
            //#endregion filesAccept set

            setBtnFileAddDisabled(isNotEditable || isEditDelete);
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const dataTablesSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataTablesSetAsync';
        let response = responseGet();
        try {
            $(`#${dtFilesId}`)?.DataTable({
                //buttons: ['excel', 'pdf', 'print', 'colvis',],
                autoWidth: false,
                columns: [
                    { title: globalSettings?.labels?.file?.[languageObj?.id], width: '70%', },
                    { title: globalSettings?.labels?.size?.[languageObj?.id], className: 'text-right', width: '25%', orderable: false, searchable: false, },
                    { title: globalSettings?.labels?.process?.[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                info: false,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                lengthChange: false,
                order: [[0, 'asc'],],
                paging: false,
                responsive: true,
                searching: false,
                //}).buttons().container().appendTo(`#${dtApartmentsId}_wrapper .col-md-6:eq(0)`);
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const queryCodeSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'queryCodeSetAsync';
        let response = responseGet();
        try {
            //#region variables
            let id = '';
            let method = '';
            let rowIndex = 0;
            let dtRowIndex = 0;
            let description = '';
            //#endregion variables

            //#region methods
            $(`#${dtFilesId} tbody`)?.on('click', 'tr', 'td', async function (e) {
                e.preventDefault();
                rowIndex = $(`#${dtFilesId}`)?.DataTable()?.row(this)?.index();
                dtRowIndex = !isUndNullEmp({ data: rowIndex, subMethod: currentMethod, })?.result ? rowIndex : dtRowIndex;
                if (!isUndNullEmp({ data: dtRowIndex, subMethod: currentMethod, })?.result) {
                    id = e?.target?.attributes?.id?.value || '';
                    method = e?.target?.attributes?.method?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (method) {
                        case 'fileOpen':
                            fileOpenAsync({ e: e, fileId: id, description: description, rowIndex: dtRowIndex, subMethod: currentMethod, });
                            break;
                        case 'fileDelete':
                            fileDeleteGetAsync({ e: e, fileId: id, description: description, rowIndex: dtRowIndex, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const defaultValueSetAsync = async ({ isModalClose = false, subMethod = '', }) => {
        const currentMethod = 'defaultValueSetAsync';
        let response = responseGet();
        try {
            if (isModalClose) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                controlsStatusSet({ processType: 2, subMethod: currentMethod, });
                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            }

            setShowModal(!isModalClose);
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    for (let ctrStr in controls) {
                        const objStr = ['buttons', 'spinners', 'icons'];
                        if (objStr?.includes(ctrStr)) {
                            for (let propStr in controls?.[ctrStr]) {
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.removeClass();
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.addClass(controls?.[ctrStr]?.[propStr]?.className);
                            }
                        }
                    }
                    break;
                case 1:
                    //$(`#${controls?.buttons?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.add?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.add?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region controls
            // $(`#${controls?.inputs?.quantity?.id}`)?.attr('readOnly', (processType !== 0));
            // $(`#${controls?.inputs?.price?.id}`)?.attr('readOnly', (processType !== 0));
            //#endregion controls

            //#region url (register / passwords)
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlRegisterStatus));
            //#endregion url (register / passwords)

            //#region url (rechaptcha)
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion url (rechaptcha)

            //#region urls
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion urls

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            //#region dataTable
            // $(`#${controls?.dataTables?.conceptsFind?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            // $(`#${controls?.dataTables?.conceptsFind?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));
            //#endregion dataTable

            if (processType !== 0) {
                $(`#${controls?.buttons?.add?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.close?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({ subMethod: 'form - onLoad', });
    }, []); //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <Modal backdrop='static' show={showModal} onHide={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - onHide', })}>
            <Modal.Header>
                <Modal.Title>
                    <img alt={globalSettings?.labels?.files?.[languageObj?.id]}
                        style={styles?.cardHeaderLogo}
                        src={globalSettings?.images?.documentLogo}>
                    </img> - {globalSettings?.labels?.files?.[languageObj?.id]}
                </Modal.Title>
                <button id={controls?.buttons?.close?.id}
                    className={controls?.buttons?.close?.className}
                    type='button'
                    data-dismiss='modal'
                    aria-label='Close'
                    onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - onHide', })}>
                </button>
            </Modal.Header>

            <form onSubmit={(e) => e?.preventDefault()}>
                <Modal.Body>
                    {/* <form onSubmit={(e) => null}> */}
                    {/* <div className='card card-outline card-primary shadow-lg'> */}
                    {/* <div className='card-header'>
                            <h6 className='card-title'>
                                <img alt={globalSettings?.labels?.files?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.documentLogo}></img> - {globalSettings?.labels?.files?.[languageObj?.id]}
                            </h6>
                        </div> */}

                    {/* <div className='card-body'> */}
                    <div className='row'>
                        <LoadingSection alt='loadingSection'
                            className={globalSettings?.react?.html?.overlay?.darkTextWhite}
                            showText={true}
                            text={globalSettings?.messages?.processing?.[languageObj?.id]}
                            height={25}
                            hidden={!showLoading}
                            width={25}
                            languageId={languageObj?.id}
                            subMethod={currentMethod} />
                        <div className='col-md-12'>
                            <div className={globalSettings?.html?.dataTables?.formats?.tableResponsiveSm}>
                                <table id={dtFilesId} className={globalSettings?.html?.dataTables?.formats?.smStripedBordered}></table>
                            </div>
                        </div>
                    </div>
                    {/* </div> */}

                    {/* <div className='card-footer'>
                            <div className='form-group text-right'>
                                <div className={btnFileAddDisabled || isNotEditable || isEditDelete ? 'btn btn-outline-info btn-file mx-1 disabled' : 'btn btn-outline-info btn-file mx-1'}>
                                    <i className={globalSettings?.icons?.paperClip}></i>
                                    <input id={inputFileId}
                                        accept={filesAccept}
                                        //disabled={isNotEditable || isEditDelete}
                                        tooltip='tooltip'
                                        title={globalSettings?.labels?.toAttach?.[languageObj?.id]}
                                        type='file'
                                        name='attachment'
                                        onChange={(e) => fileAddAsync(e, 0)} />
                                </div>
                                <button className='btn btn-outline-danger'
                                    disabled={isNotEditable || isEditDelete}
                                    hidden id={btnFileDeleteId}
                                    onClick={() => fileDeletePostAsync()}
                                    type='button'>
                                </button>
                                <button className='btn btn-outline-success'
                                    onClick={() => defaultValueSetAsync(true)}
                                    tooltip='tooltip'
                                    title={globalSettings?.labels?.close?.[languageObj?.id]}
                                    type='button'>
                                    <i className={globalSettings?.icons?.arrowCircleLeft}></i>
                                </button>
                            </div>
                        </div> */}
                    {/* </div> */}
                    {/* </form> */}
                </Modal.Body>

                <Modal.Footer >
                    <div className='form-group text-right'>
                        <div className={btnFileAddDisabled || isNotEditable || isEditDelete ? controls?.buttons?.add?.defaultClassDisabled : controls?.buttons?.add?.className}>
                            {/* <i className={globalSettings?.icons?.paperClip}></i> */}
                            <i id={controls?.icons?.add?.id} className={controls?.icons?.add?.className} /> <span id={controls?.spinners?.add?.id} className='' aria-hidden='true'></span>
                            <input id={controls?.buttons?.add?.id}
                                //id={controls?.buttons?.add?.id}
                                accept={filesAccept}
                                //disabled={isNotEditable || isEditDelete}
                                tooltip='tooltip'
                                title={globalSettings?.labels?.toAttach?.[languageObj?.id]}
                                type='file'
                                name='attachment'
                                onChange={(e) => fileAddAsync({ e: e, subMethod: 'btn - fileAdd', })} />
                        </div>
                        <button id={controls?.buttons?.delete?.id}
                            className={controls?.buttons?.delete?.className}
                            //id={btnFileDeleteId}
                            //className='btn btn-outline-danger'
                            disabled={isNotEditable || isEditDelete}
                            hidden
                            onClick={(e) => fileDeletePostAsync({ e: e, subMethod: 'btn - fileDeletePost', })}
                            type='button'>
                            <i id={controls?.icons?.delete?.id} className={controls?.icons?.delete?.className} /> <span id={controls?.spinners?.delete?.id} className='' aria-hidden='true'></span>
                        </button>
                        <button id={controls?.buttons?.back?.id}
                            className={controls?.buttons?.back?.className}
                            //className='btn btn-outline-success'
                            onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - onHide', })}
                            tooltip='tooltip'
                            title={globalSettings?.labels?.close?.[languageObj?.id]}
                            type='button'>
                            <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                        </button>
                    </div>
                </Modal.Footer>
            </form>
        </Modal>
    )
}